import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import {Table,Button} from 'antd'
import TopSearch from "@/components/TopSearch"
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
//import ListComponent from "@/components/listComponent"
import { poListStatistics, poListStatisticsExport,poListStatisticsTotal } from "@/service/statistics"
import { MyContext } from "@/store/myContext"
import moment from "moment"
import { message } from "antd"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { formatNum } from '@/erp_subpackage/utils/util';
import useGlobalModel,{ transPgToPagination } from "@/erp_subpackage/model/globalModel";
import {YhBox} from '@//erp_subpackage/components/YhBox'
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';



export default () => {
    
const { t } = useTranslation();
const { state,Option } = useContext(MyContext)
    const [list, setList] = useState([]) //列表
    const { user: { shopId, shopCode, shopName, organType, orgCode, orgName },fetchFmsShopList } = useGlobalModel()
    const [searchValue, setSearchValue] = useState({
        // startTime: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
        // endTime: moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss"),
    })
    const [shopList, setShopList] = useState([])
    const { getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
    const initPgCfg = { pageSize: 10, current: 1 }
    const [pgCfg, setPgCfg] = useState(initPgCfg)
    const initdesc = {
        receivedAmount:0,
        paidAmount:0,
        payAmount:0,
        purchaseQuantity:0
    }
    const [order, setOrder] = useState({})
    const [descTotal,setDescTotal,] =useState(initdesc)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (state.activeMenu === "poListStatistics") {
            loadData()
        }

    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetchFmsShopList('').then(arr => {
            setShopList(arr)  
        })
    }, [])

    //列表数据
    const loadData = async( page,search = searchValue, ) => {
        setLoading(true)
        let data = {
             ...search,
             pageSize: page?.pageSize ?? pgCfg.pageSize ?? initPgCfg.pageSize,
             pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? initPgCfg.current,
            shopCode,
            shopId
        }
        let {retData} =  await poListStatistics(data)
        let {records,...pg} =retData
        setList(records)
        setLoading(false)
        setPgCfg(transPgToPagination(pg));
        poListStatisticsTotal(data).then(({retData:totalVo})=>{
            setDescTotal(totalVo)  
        })
    }
    //导出
    const handleExport = (search=searchValue) => {
 
        const searchParams = {
            searchItem:{
                ...search,
                shopId: search.shopId ?? shopId,
                pageSize: 1,
                pageNum:15
            }
        }
        poListStatisticsExport(searchParams).then((res) => {
            message.success(res.retData)
        })
        
    }


   
     //列表button
           const topButtons = <>
           <Button
                 className="btn-item"
                 shape="round"
                 onClick={() => handleExport()}
           > {t(`statistics.poListStatistics.index.导出`)}</Button>
     </>

    //table配置
    const columns = [
        {
            align: "center",
            width: 60,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.序号`),
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.采购单号`),
            dataIndex: 'documentNumber',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.供应商名称`),
            dataIndex: 'supplierName',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.单据状态`),
            dataIndex: 'status',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.供应商类型`),
            dataIndex:'supplierTypeName',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.供应商采购频次`),
            dataIndex:'purchaseFrequency',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.单据类型`),
            dataIndex: 'type',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            align: "center",
            width: 140,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.单据状态`),
            dataIndex: 'status',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
           
    
        },
        {
            align: "center",
            width: 140,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.支付状态`),
            dataIndex: 'payStatus',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
        },
        {
            align: "center",
            width: 120,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.结算类型`),
            dataIndex: 'payType',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
           
        },

        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.制单员`),
            dataIndex: 'createUser',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.结算日期`),
            dataIndex: 'settleTime',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.采购金额`),
            dataIndex: 'totalAmount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.已付金额`),
            dataIndex: 'saleCost',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.已收金额`),
            dataIndex: 'received',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.poListStatistics.index.分店`),
            dataIndex: 'shopName',
            render: (text) => <YhTooltip text={text} />,
        },
    ]
       //搜索JSON
       const searchList = {
        normalList: [
            
            {
                type: 'input',
                placeholder: t(`statistics.poListStatistics.index.供应商名称`),
                valueName: 'supplierName',
            },
            {
                type: 'input',
                placeholder: t(`statistics.poListStatistics.index.采购单号`),
                valueName: 'code',
            },
            {
                type: 'input',
                placeholder: t(`statistics.poListStatistics.index.制单员`),
                valueName: 'createUser',
            },
            {
                type: 'RangePicker',
                valueName: ['settlementStartTime', 'settlementEndTime'],
                placeholder: [t(`statistics.poListStatistics.index.结算起始日期`), t(`statistics.poListStatistics.index.结算结束日期`)],
                format: "YYYY-MM-DD",
                span: 16,
                xxl: 8,
            },
        ],
        hideList: [
            {
                type: 'select',
                placeholder: t(`statistics.poListStatistics.index.采购类型`),
                valueName: 'purchaseTypeCode',
                optionList: () =>
                getSelectedDictOne(DictCodeEnmu.PURCHASE_TEPE).map((item) =>
                ( 
                <Option key={item.key} value={item.value}>
                    {item.label}
                </Option>
            )),
            },
            {
                type: 'select',
                placeholder: t(`statistics.poListStatistics.index.结算类型`),
                valueName: 'payType',
                optionList: () =>
                getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE).map((item) =>
                ( 
                <Option key={item.key} value={item.value}>
                    {item.label}
                </Option>
            )),
            },
            {
                type: 'select',
                placeholder: t(`statistics.poListStatistics.index.供应商类型`),
                valueName: 'supplierTypeCode',
                optionList: () =>
                getSelectedDictOne(DictCodeEnmu.SUPPLIER_TYPE).map((item) =>
                ( 
                <Option key={item.key} value={item.value}>
                    {item.label}
                </Option>
            )),
            },
            {
                type: 'select',
                placeholder: t(`statistics.poListStatistics.index.单据类型`),
                valueName: 'tradeTypeCode',
                optionList: () =>
                getSelectedDictOne(DictCodeEnmu.TRADE_TYPE).map((item) =>
                    ( 
                    <Option key={item.key} value={item.value}>
                        {item.label}
                    </Option>
                )),
                
            },
            {
                type: 'RangePicker',
                valueName: ['startTime', 'endTime'],
                placeholder: [t(`statistics.poListStatistics.index.开单起始日期`), t(`statistics.poListStatistics.index.开单结束日期`)],
                format: "YYYY-MM-DD",
                span: 16,
                xxl: 8,
            },
            
        ],
    }
    const desc = [
        {
            label: t(`statistics.poListStatistics.index.采购数量`),
            value: descTotal.purchaseQuantity,
            color: "red"
        },
        {
            label: t(`statistics.poListStatistics.index.结算金额`),
            value: descTotal.payAmount,
            color: "red"
        },
        {
            label: t(`statistics.poListStatistics.index.已付金额`),
            value:descTotal.paidAmount,
            color: "red"
        },
        {
            label: t(`statistics.poListStatistics.index.已收金额`),
            value:descTotal.receivedAmount,
            color: "red"
        }
        
    ]

    return (
        <>
            {state.activeMenu === "poListStatistics" && (
                <>
                    <TopSearch
                        title= {t(`statistics.poListStatistics.index.采购单报表`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                        // defaultSearch={{
                        // }}
                    />
                    <YhBox title= {t(`statistics.poListStatistics.index.采购单报表`)} descriptions={desc}   style={{marginTop:20}} action={topButtons}>
                    <Table
                  
                        columns={columns}
                        dataSource={list}
                        pagination={ 
                            
                            {   ...pgCfg,
                                showSizeChanger:true,
                                position: ["bottomCenter"],
                                showTotal: () => `${t(`statistics.poListStatistics.index.共`)}${pgCfg.total}${t(`statistics.poListStatistics.index.条`)}`,
                                onChange: (pageNum,pageSize) => {
                                    loadData( {pageNum,pageSize})
                                }
                            }
                        }
                       
                        scroll={{ x: "max-content" }}
                        loading={loading}
                    />
                    </YhBox>
                </>
            )}
        </>
    )
}
